// Balk bovenaan wanneer een Deccos-superadmin in een tenant kijkt waar hij
// géén teamlid van is. Twee redenen om dit zichtbaar te maken:
//
//   - Je kijkt in klantdata. Dat hoort nooit stilletjes te gebeuren.
//   - Zonder lopende sessie weigeren de Firestore-rules alles, en dan lijkt
//     de tenant leeg in plaats van afgeschermd. De banner zegt wélke van de
//     twee het is.
//
// AI-CONTEXT: See docs/features/superadmin-tenant-access.md

import { useContext, useEffect, useState } from 'react'
import { Auth } from '../../StateManagment/Auth'
import { client } from '../../hooks/Client'
import useSuperAdminSession from '../../hooks/useSuperAdminSession'
import useCompagnyMetaById from '../../hooks/useCompagnyMetaById'
import { formatTimeLeft } from '../../helpers/superAdmin/readSuperAdminSession'
import SuperAdminSessionModal from '../superAdmin/SuperAdminSessionModal'

const TICK_MS = 30000

const SuperAdminBanner = () => {

    const [authO] = useContext(Auth)
    const { session, endSession } = useSuperAdminSession()
    const { compagnyMeta } = useCompagnyMetaById(client)

    const [modalOpen, setModalOpen] = useState(false)
    const [busy, setBusy] = useState(false)
    const [now, setNow] = useState(() => Date.now())

    // Aftellen: de banner moet zelf verlopen, ook zonder navigatie.
    useEffect(() => {
        const id = setInterval(() => setNow(Date.now()), TICK_MS)
        return () => clearInterval(id)
    }, [])

    const isSuperAdmin = authO?.SuperAdmin === true
    const compagnies = Array.isArray(authO?.Compagny) ? authO.Compagny : []
    const isMember = compagnies.includes(client)

    const msLeft = session?.expiresAt ? session.expiresAt - now : 0
    const sessionActive = session?.compagnyId === client && msLeft > 0

    // Teamleden en gewone gebruikers zien niets — dit is geen kop op elke pagina.
    if (!isSuperAdmin || isMember || !client) return null

    const tenantName = compagnyMeta?.CommunityName || client

    const stop = async () => {
        setBusy(true)
        await endSession()
        setBusy(false)
    }

    return (
        <div className={sessionActive ? 'superadmin-banner' : 'superadmin-banner superadmin-banner-idle'}>
            <div className="superadmin-banner-text">
                {sessionActive ? (
                    <>
                        <strong>Superadmin-sessie</strong> in <strong>{tenantName}</strong> — je bent hier geen teamlid.
                        Nog {formatTimeLeft(msLeft)}.
                    </>
                ) : (
                    <>
                        Je bent geen teamlid van <strong>{tenantName}</strong> en hebt geen lopende superadmin-sessie.
                        De gegevens van deze omgeving blijven leeg tot je er een start.
                    </>
                )}
            </div>

            {sessionActive ? (
                <button className="superadmin-banner-button" onClick={stop} disabled={busy}>
                    Sessie beëindigen
                </button>
            ) : (
                <button className="superadmin-banner-button" onClick={() => setModalOpen(true)}>
                    Sessie starten
                </button>
            )}

            <SuperAdminSessionModal
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                compagnyId={client}
                tenantName={tenantName}
                // Herladen na het starten: bestaande Firestore-listeners hangen
                // nog aan het oude token en zouden anders leeg blijven.
                onStarted={() => window.location.reload()}
            />
        </div>
    )
}

export default SuperAdminBanner
